import { render } from "./recently-viewed.vue?vue&type=template&id=66ce498e&scoped=true"
import script from "./recently-viewed.vue?vue&type=script&lang=js"
export * from "./recently-viewed.vue?vue&type=script&lang=js"

import "./recently-viewed.vue?vue&type=style&index=0&id=66ce498e&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ce498e"]])

export default __exports__